//Base Extension//
(function (win) {

	//-[String prototypes ]-----------------------------------------------------------------------------------------------------------------
	win.String.prototype.getDateFromOzDateString = function () {
		var splited = this.split(" ");
		var dd = splited[0].substring(0, 2);
		var mm = splited[0].substring(3, 5);
		var yyyy = splited[0].length > 8 ? splited[0].substring(6, 10) : '20' + splited[0].substring(6, 8);
		var date = mm + '/' + dd + '/' + yyyy;
		if (splited.length > 1) {
			date = date + ' ' + splited[1] + ' ' + splited[2];
		}
		return new Date(date);
	};
	win.String.prototype.fromOzSaleToDefault = function () {
		return this.getDateFromOzDateString().format();
	};
	win.String.prototype.fromMStoOzSaleDate = function () {
		return this.getDateFromMS().format('ozDateTime');
	};
	win.String.prototype.fromMStoOzSaleDateShort = function () {
		return this.getDateFromMS().format('ozDateTimeShort');
	};
	win.String.prototype.fromMStoBiSaleDate = function () {
		return this.getDateFromMS().format('biDateTimeFull');
	};
	win.String.prototype.getDateFromMS = function () {
		var msDateRegExp = new RegExp("^\/Date\\((([-+])?[0-9]+)(([-+])([0-9]{2})([0-9]{2}))?\\)\/$");
		var msMatch = this.match(msDateRegExp);
		if (msMatch !== null) {
			timestamp = new Date(parseInt(msMatch[1], 10));
			if (msMatch[3]) {
				var offset = Number(msMatch[5]) * 60 + Number(msMatch[6]);
				offset *= ((msMatch[4] == '-') ? 1 : -1);
				offset -= timestamp.getTimezoneOffset();
				timestamp.setTime(Number(Number(timestamp) + (offset * 60 * 1000)));
			}
			return timestamp;
		} else {
			return new Date(this);
		}
	};
	win.String.prototype.parseFromOzDate = function () {
		var splited = this.split(" ");
		var dd = splited[0].substring(0, 2);
		var mm = splited[0].substring(3, 5);
		var yyyy = splited[0].length > 8 ? splited[0].substring(6, 10) : '20' + splited[0].substring(6, 8);
		var date = mm + '/' + dd + '/' + yyyy
		if (splited.length > 1) {
			date = date + ' ' + splited[1] + ' ' + splited[2];
		}
		return new Date(date);
	};
	win.String.prototype.dateFromOzDateTimeFull = function () {
		if (this === undefined || this == null || this == "")
			return new Date();
		else
			return new Date(Date.parse(this));
	};
	win.String.prototype.bool = function () {
		switch (this.toLowerCase()) {
		case "true": case "yes": case "1": return true;
		case "false": case "no": case "0": case null: return false;
		default: return Boolean(this);
		}
	};
	win.String.prototype.format = function () {
		return String.format(this, arguments.length == 1 ? arguments[0] : arguments);
	};
	win.String.format = function (source, params) {
		var _toString = function (obj, format) {
			var ctor = function (o) {
				if (typeof o == 'number')
					return Number;
				else if (typeof o == 'boolean')
					return Boolean;
				else if (typeof o == 'string')
					return String;
				else
					return o.constructor;
			}(obj);
			var proto = ctor.prototype;
			var formatter = typeof obj != 'string' ? proto ? proto.format || proto.toString : obj.format || obj.toString : obj.toString;
			if (formatter)
				if (typeof format == 'undefined' || format == "")
					return formatter.call(obj);
				else
					return formatter.call(obj, format);
			else
				return "";
		};
		if (arguments.length == 1)
			return function () {
				return String.format.apply(null, [source].concat(Array.prototype.slice.call(arguments, 0)));
			};
		if (arguments.length == 2 && typeof params != 'object' && typeof params != 'array')
			params = [params];
		if (arguments.length > 2)
			params = Array.prototype.slice.call(arguments, 1);
		source = source.replace(/\{\{|\}\}|\{([^}: ]+?)(?::([^}]*?))?\}/g, function (match, num, format) {
			if (match == "{{") return "{";
			if (match == "}}") return "}";
			if (typeof params[num] != 'undefined' && params[num] !== null) {
				return _toString(params[num], format);
			} else {
				return "";
			}
		});
		return source;
	};
	win.String.prototype.replaceCaseInsensitive = function (oldStr, newStr) {
		oldStr = oldStr.replace(new RegExp('\\[', 'gi'), '\\[').replace(new RegExp('\\]', 'gi'), '\\]');
		var rexexp = new RegExp(oldStr, 'gi');
		return this.replace(rexexp, newStr);
	};
	win.String.prototype.nlToBr = function () {
		return this.replace(/\\r\\n|\\n|\r\n|\n/gi, '<br />').replace(/\<br\>/gi, "<br />");
	};
	win.String.prototype.brToNl = function () {
		return this.replace(/<br\s*\/?>/gi, '\n');
	};
	win.String.prototype.isGuid = function () {
		return this.match(/^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/);
	};
	win.String.prototype.toLowerFirstChar = function () {
		return this.charAt(0).toLowerCase() + this.slice(1);
	};
})(window);